import { BatchedMesh, InstancedMesh, Matrix4, type Object3D } from 'three';
import type { Vec3 } from '../geo/types';
import type { LifeRoute } from '../world/life/types';

export interface AnimalDiagnostic {
  readonly id: string;
  readonly role: string;
  readonly position: Vec3;
  readonly heading: number;
  readonly visible: boolean;
}

/** The actual rendered bodies let silent browser checks follow the city's moving animals. */
export function animalDiagnostics(root: Object3D): readonly AnimalDiagnostic[] {
  const body = root.getObjectByName('life-cast-body');
  if (!(body instanceof BatchedMesh)) return [];
  const routes = body.userData['lifeRoutes'] as readonly LifeRoute[];
  const matrix = new Matrix4();
  const cast: AnimalDiagnostic[] = routes.map((route, i) => {
    body.getMatrixAt(i, matrix);
    const e = matrix.elements;
    return {
      id: route.id,
      role: route.role,
      position: [e[12], e[13], e[14]] as Vec3,
      heading: Math.atan2(-e[2], e[0]),
      visible: body.getVisibleAt(i),
    };
  });
  for (const species of ['horse', 'ox']) {
    const draft = root.getObjectByName(`draft-${species}-body`);
    if (!(draft instanceof InstancedMesh)) continue;
    const kinds = draft.userData['draftKinds'] as readonly string[];
    for (let i = 0; i < draft.count; i++) {
      draft.getMatrixAt(i, matrix);
      const e = matrix.elements;
      cast.push({
        id: `draft-${species}-${i}`,
        role: kinds[i]!,
        position: [e[12], e[13], e[14]],
        heading: Math.atan2(-e[2], e[0]),
        visible: matrix.determinant() !== 0,
      });
    }
  }
  return cast;
}
